import React from 'react';
import {
  EventType,
  EventTypeStyle,
  getEventTypeStyle,
  getProjectColor,
} from 'src/utils/BigCalendarColourGeneratorUtils';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { CalcomEventPill } from 'src/pages/Calendar/CalcomIntegration/components/CalcomEventDetails/CalcomEventDetails';
import JuniperScheduledPill from './JuniperScheduledPill';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import './event-details-header.scss';

interface IEventDetailsHeaderProps {
  originalEvent: ICalendarEventData;
  eventTypeString: string;
  eventType: EventType;
  isCalcom: boolean;
}

const EventDetailsHeader = ({
  originalEvent,
  eventTypeString,
  eventType,
  isCalcom,
}: IEventDetailsHeaderProps) => {
  const eventStyle: EventTypeStyle = getEventTypeStyle(eventType);

  return (
    <div className="event-details-header">
      <CategoryPill
        text={eventTypeString}
        color={eventStyle.backgroundColor}
        textColor={eventStyle.textColor}
        eventType={eventType}
      />
      {originalEvent.propertyName && (
        <CategoryPill
          text={originalEvent.propertyName}
          color={getProjectColor(originalEvent.propertyName)}
          textColor="white" // Properties will use white text like in the legend.
        />
      )}
      {isCalcom ? <CalcomEventPill /> : <JuniperScheduledPill />}
    </div>
  );
};

export default EventDetailsHeader;